import { useCallback, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useConfigShallowStore } from '../../../stores';
import { useKioskFillingExperienceContext } from '../provider';
import { PatronForm, PatronFormValues } from './patron-form';
import { PatronFormWelcomeScreen } from './patron-form-welcome-screen';

export const NewPatronForm = ({ onWelcomeAccept }: { onWelcomeAccept?: () => void }) => {
  const { locationId, documentType, patronType, documentId } = useKioskFillingExperienceContext();
  const { setPerson } = useConfigShallowStore('setPerson');
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    (values: PatronFormValues) => {
      setPerson({
        firstName: values.firstName,
        lastName: values.lastName,
        phoneNumber: values.mobilePhone,
        birthdate: values.birthdate,
        email: values.email,
        city: values.city,
        state: values.state,
        zipCode: values.postalCode,
        streetAddress1: values.address1,
        streetAddress2: values.address2,
      });
      if ((documentType === 'form' || documentType === 'packet') && documentId) {
        navigate({
          to: `/form`,
          search: {
            [documentType === 'packet' ? 'packetId' : 'formId']: documentId,
            companyId: locationId,
            origin: 'kiosk',
          },
        });
        return;
      }
      navigate({ to: `/kiosk/${locationId}` });
    },
    [documentId, documentType, locationId, navigate, setPerson]
  );

  if (showWelcomeScreen) {
    return (
      <PatronFormWelcomeScreen
        locationId={locationId}
        onAccept={() => {
          setShowWelcomeScreen(false);
          onWelcomeAccept?.();
        }}
      />
    );
  }

  return <PatronForm onSubmit={handleSubmit} patronType={patronType} />;
};
